import * as React from 'react';
import * as I18n from 'i18n-js';
import LoadingBars from '@reverbdotcom/commons/dist/components/loading_bars';

export default function ConnectingToPacklink() {
  return (
    <div className="bg-white mlr-2">
      <div className="cms-text">
        <h2 className="align-center">{I18n.t('discovery.packlink.connectingToPacklink')}</h2>
        <div className="d-flex fx-align-center fx-justify-center height-vh-10 pb-4">
          <LoadingBars />
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/packlink_connecting_to_packlink.tsx